/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LedgerWithdrawRequestSelfOptions,
  LedgerWithdrawRequestSelfStatus201,
  LedgerWithdrawRequestSelfStatus400,
  LedgerWithdrawRequestSelfStatus403,
  LedgerWithdrawRequestSelfStatus500,
} from '../types/LedgerWithdrawRequestSelf'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { ledgerWithdrawRequestSelf } from '../clients/ledgerWithdrawRequestSelf'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const ledgerWithdrawRequestSelfMutationKey = () =>
  [{ url: '/v1/ledger/withdraw/requests/self' }] as const

export function ledgerWithdrawRequestSelfMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = ledgerWithdrawRequestSelfMutationKey()
  return mutationOptions<
    LedgerWithdrawRequestSelfStatus201,
    ResponseErrorConfig<
      | LedgerWithdrawRequestSelfStatus400
      | LedgerWithdrawRequestSelfStatus403
      | LedgerWithdrawRequestSelfStatus500
    >,
    LedgerWithdrawRequestSelfOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return ledgerWithdrawRequestSelf({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Withdraw assets from the logged in user's account to the outside world. Note that this does not interact with any external systems; it simply deducts the amount from the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Initiate a withdrawal request for the logged in user to the outside world
 * {@link /v1/ledger/withdraw/requests/self}
 */
export function useLedgerWithdrawRequestSelf<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LedgerWithdrawRequestSelfStatus201,
      ResponseErrorConfig<
        | LedgerWithdrawRequestSelfStatus400
        | LedgerWithdrawRequestSelfStatus403
        | LedgerWithdrawRequestSelfStatus500
      >,
      LedgerWithdrawRequestSelfOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? ledgerWithdrawRequestSelfMutationKey()

  const baseOptions = ledgerWithdrawRequestSelfMutationOptions(config) as UseMutationOptions<
    LedgerWithdrawRequestSelfStatus201,
    ResponseErrorConfig<
      | LedgerWithdrawRequestSelfStatus400
      | LedgerWithdrawRequestSelfStatus403
      | LedgerWithdrawRequestSelfStatus500
    >,
    LedgerWithdrawRequestSelfOptions,
    TContext
  >

  return useMutation<
    LedgerWithdrawRequestSelfStatus201,
    ResponseErrorConfig<
      | LedgerWithdrawRequestSelfStatus400
      | LedgerWithdrawRequestSelfStatus403
      | LedgerWithdrawRequestSelfStatus500
    >,
    LedgerWithdrawRequestSelfOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LedgerWithdrawRequestSelfStatus201,
    ResponseErrorConfig<
      | LedgerWithdrawRequestSelfStatus400
      | LedgerWithdrawRequestSelfStatus403
      | LedgerWithdrawRequestSelfStatus500
    >,
    LedgerWithdrawRequestSelfOptions,
    TContext
  >
}
